<template>
  <v-card flat id="statcard"  max-width="350" width="100%" color="lsidebg" 
   class="mb-2 mr-sm-3 mr-md-0 lside-wdgt d-print-none" align-self="flex-start"> 
    <v-card-title class="pt-2 pb-1 pl-2">
      <h5 class="wdgt-title darkgrey--text" >{{$t('database.wdg_status')}}</h5>
    </v-card-title>

    <v-card-text class="stat">
      <v-row v-for="(item, index) in this.statinfo" :key="index" no-gutters >
        <v-col class="py-0 ma-0">
          <v-row v-if="index===0" no-gutters class="pa-0 ma-0 pb-1">
            <v-divider role="presentation" />
          </v-row>
          <v-row no-gutters class="pa-0 ma-0"  align="baseline">
            <v-col cols="5" sm="6" class="pt-1 pb-1">
              <span class="statlabel darkgrey-text">{{item.label}}</span> 
            </v-col>
            <v-col cols="7" sm="6" class="pt-1 pb-1">
              <span class="statval darkgrey-text">{{item.val}} {{item.unit}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters class="pa-0 ma-0 pb-1">
            <v-divider role="presentation" />
          </v-row>
        </v-col>
      </v-row>
		</v-card-text>
	</v-card>
</template>

<script>
  export default {
    name:'hklii-statuswidget',
    props:{
      statinfo: {type: Array, required: true}
    }
  }
</script>

<style scoped>
  .stat{
    font-size: 9.3pt;
    line-height: 12.5pt;
  }

  .statlabel{
    font-stretch: semi-condensed;
    word-break: normal
  }

  .statval{
    font-weight: 700;
    word-break: normal
  }
</style>